/* begin general import */

import _ from "lodash";
import { ResponsibilityRoleMapping } from "models/ResponsibilityRoleMapping";
import React, { useCallback, useState } from "react";
import { ConfigField } from "services/page-services/field-service";

/* end individual import */

export function useResponsibilityRoleMapping(
  handleChangeListField: (config: ConfigField) => (data?: any[]) => void
) {
  const [listResponsibilityRole, setListResponsibilityRole] = useState<
    ResponsibilityRoleMapping[]
  >([]);

  const [visibleResponsibilityRoleModal, setVisibleResponsibilityRoleModal] =
    useState<boolean>(false);

  const handleOpenResponsibilityRoleModal = useCallback(
    (responsibilityRoleMappings: ResponsibilityRoleMapping[]) => {
      if (_.isArray(responsibilityRoleMappings))
        setListResponsibilityRole([...responsibilityRoleMappings]);
      else setListResponsibilityRole([]);
      setVisibleResponsibilityRoleModal(true);
    },
    []
  );

  const handleCloseResponsibilityRoleModal = React.useCallback(() => {
    setVisibleResponsibilityRoleModal(false);
  }, []);

  const handleSaveResponsibilityRoleModal = useCallback(
    (listResponsibilityRole) => {
      handleChangeListField({
        fieldName: "responsibilityRoleMappings",
      })(listResponsibilityRole);
      handleCloseResponsibilityRoleModal();
    },
    [handleChangeListField, handleCloseResponsibilityRoleModal]
  );

  return {
    listResponsibilityRole,
    visibleResponsibilityRoleModal,
    handleOpenResponsibilityRoleModal,
    handleCloseResponsibilityRoleModal,
    handleSaveResponsibilityRoleModal,
  };
}
